






























































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitProjectData, emptyData, getInfo, postData, putData, UnitProjectImplementData, emptyImplement } from '@/api/heritageUnit/unitProject'
import { getLookupByType, DDLItem } from '@/api/common/select'
import { enFirstType, enLookupType } from '@/configs/enums'
import { validateIntKey, validateLngLat, showVaildMsg } from '@/configs/validate'
import { getDDLItem, tryToInt } from '@/configs/functions'
import { OfficialDocData } from '@/api/officialDoc/doc'
import Element from 'element-ui'
import DocSelector from '@/components/officialDoc/select.vue'
import UnitProjectImplementForm from './implement.vue'
import FormDialog from '@/components/dialog/formDialog.vue'

const getFormRules = (form: { [key: string]: string }) => {
  return {
    ProjectName: [{ required: true, message: '请输入工程名称', trigger: 'blur' }],
    PropertiesId: [{ required: true, validator: validateIntKey('请选择工程性质'), trigger: 'blur' }]
  }
}
@Component({
  components: { FormDialog, DocSelector, UnitProjectImplementForm }
})
export default class UnitProjectForm extends Vue {
  public name = 'UnitProjectForm'
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false

  public expandNames: string[] = ['project', 'implement']
  public loading: boolean = false
  public implementIndex: number = -1
  public propertiesList: DDLItem[] = []
  public form: UnitProjectData = Object.assign({}, emptyData)
  public rules = getFormRules(this.form)
  public $refs!: {
    formData: Element.Form
  }
  get yearMonth(): string {
    const f = this.form
    var data = ''
    if (f.LxYear > 0 && f.LxMonth > 0) {
      data = f.LxYear.toString() + '-' + f.LxMonth.toString()
    }
    return data
  }
  set yearMonth(data: string) {
    const f = this.form
    if (data != '') {
      let sp = data.split('-')
      f.LxYear = tryToInt(sp[0])
      f.LxMonth = tryToInt(sp[1])
    }
    else {
      f.LxYear = f.LxMonth = 0
    }
  }
  public getDoc(info: { data: OfficialDocData, refTo: string }) {
    this.form.DocId = info.data.Id
  }
  public created() {
  }
  public fetchSource() {
    const firstType = enFirstType.Select
    if (this.propertiesList.length === 0) {
      getLookupByType(enLookupType.ProjectProperties, firstType).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          this.propertiesList = data
        }
      })
    }
  }
  public mounted() {
    window.eventBus.$on("openUnitProjectForm", (info: { unitId: number, dataId: number }) => {
      this.fetchSource()
      this.fetchData(info)
    })

    window.eventBus.$on('submitUnitProjectImplementForm', (data: UnitProjectImplementData) => {
      this.updateImplement(data)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("openUnitProjectForm")
    window.eventBus.$off('submitUnitProjectImplementForm')
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public fetchData(info: { unitId: number, dataId: number }) {
    this.open()
    this.loading = true
    getInfo(info.dataId).then((response: { data: any }) => {
      this.form = response.data
      if (info.dataId === 0) {
        this.form.UnitId = info.unitId
      }
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
  public sendData(data: UnitProjectData) {
    window.eventBus.$emit("submitUnitProjectForm", {
      data: data
    })
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        const f = Object.assign({}, this.form)
        const promist = f.Id > 0 ? putData(f.Id, f) : postData(f)
        promist.then((response: { data: any }) => {
          const data = response.data
          const msg = this.form.Id > 0 ? '保存' : '创建'
          if (data && !data.IsError) {
            this.$message({
              message: `${msg}成功`,
              type: 'success'
            })
            this.sendData(f)
            this.close()
          } else {
            this.$message({
              dangerouslyUseHTMLString: true, message: `${data.Message}`,
              type: 'warning'
            })
            console.log(response)
          }
        }, (data: any) => {
          console.log(data)
        })
      }
      else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
  /*方案维护*/
  public addImplement() {
    this.implementIndex = -1
    const item = Object.assign({}, emptyImplement)
    this.showImplementForm(item)
  }
  public editImplement(index: number) {
    this.implementIndex = index
    const item = this.form.ImplementList[index]
    this.showImplementForm(item)
  }
  public removeImplement(index: number) {
    this.$confirm(`确定要删除吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.form.ImplementList.splice(index, 1)
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '操作已取消'
        })
      })
  }
  public showImplementForm(data: UnitProjectImplementData) {
    window.eventBus.$emit('openUnitProjectImplementForm', data)
  }
  public closeDataForm() {
    console.log('closeUnitProjectImplementForm')
  }
  public updateImplement(data: UnitProjectImplementData) {
    if (this.implementIndex >= 0) {
      this.$set(this.form.ImplementList, this.implementIndex, data)
    }
    else {
      this.form.ImplementList.push(data)
    }
    this.implementIndex = -1
  }
}
